import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";


import {CustomValidators} from '../components/custom-validator/custom-validator.component';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  model: any = {};
  id: any;
  loading = false;
  loginError = false;
  returnUrl: string;
  public frmSignup: FormGroup;
  @ViewChild('swalModalDelete') swalModalDelete: any;
  loginSuccess = false;
  public passFieldTextType: boolean;
  public cPassFieldTextType: boolean;



  registrationFormGroup: FormGroup;
  passwordFormGroup: FormGroup;
  constructor(private formBuilder: FormBuilder , private fb: FormBuilder,private location: Location,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService) {

    this.route.params.subscribe(params => {
      this.id = params['id'];

    });



    this.frmSignup = this.createSignupForm();

    this.passwordFormGroup = this.formBuilder.group({
      password: [
        null,
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          // check whether the entered password has a special character
          CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
          ),
          Validators.minLength(8)
        ])
      ],
      repeatPassword: ['', Validators.required]
    }, {
      validator: CustomValidators.validate.bind(this)
    });
    this.registrationFormGroup = this.formBuilder.group({
      passwordFormGroup: this.passwordFormGroup
    });
  }

  ngOnInit() {
    this.returnUrl = 'dashboard';//this.route.snapshot.queryParams['returnUrl'] || '/';
    // reset login status
    if (localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) {
     this.router.navigate([this.returnUrl]);
    } else {
      //  this.authenticationService.logout();
    }
  }


  createSignupForm(): FormGroup {

    return this.fb.group(

        {

          password: [
            null,
            Validators.compose([
              Validators.required,
              // check whether the entered password has a number
              CustomValidators.patternValidator(/\d/, {
                hasNumber: true
              }),
              // check whether the entered password has upper case letter
              CustomValidators.patternValidator(/[A-Z]/, {
                hasCapitalCase: true
              }),
              // check whether the entered password has a lower case letter
              CustomValidators.patternValidator(/[a-z]/, {
                hasSmallCase: true
              }),
              // check whether the entered password has a special character
              CustomValidators.patternValidator(
                  /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                  {
                    hasSpecialCharacters: true
                  }
              ),
              Validators.minLength(8)
            ])
          ],
          confirmPassword: [null, Validators.compose([Validators.required])]
        },
        {
          // check whether our password and confirm password match
          validator: CustomValidators.passwordMatchValidator
        }
    );

  }


  submit(){
    let that = this;
    this.registrationFormGroup.value.passwordFormGroup.id=this.id;
      this.authenticationService
          .forgotpasswordReset()
          .get(this.registrationFormGroup.value.passwordFormGroup)
          .subscribe(
              data => {
                this.loginError=false;
                this.loginSuccess = data.data.message;
                that.login(data.data.data.user,data.data.data.pass);
              },
              error => {
                this.loginError = error.data.message;
                this.loginSuccess =false;
              });
  }

  login(user,pass) {
    this.authenticationService.login(user, pass)
        .subscribe(
            data => {
              this.router.navigate(['dashboard']);
            },
            error => {
            });
  }

  toggleFieldTextType(field) {
    field === "password"
      ? (this.passFieldTextType = !this.passFieldTextType)
      : (this.cPassFieldTextType = !this.cPassFieldTextType);
  }

}



// WEBPACK FOOTER //
// /app/src/app/reset-password/reset-password.component.ts